import styled from 'styled-components'

export const Icon = styled.div`
  cursor:pointer;
  &:hover {
    color:red;
  }
`